export default __webpack_public_path__ + "static/media/weddingEffectRental.2de1c53c.png";